import { Injectable } from '@angular/core';

import type { ScheduledPayment } from '@amfam/shared/models/lib/billing/scheduled-payment.model';

@Injectable({
  providedIn: 'root'
})
export class PaymentAccountTransmuteService {
  constructor() {}

  // SK: This method returns whether payment is scheduled or not for BA# while add/edit autopay.
  public getScheduledPaymentStatus(
    scheduledPayments: ScheduledPayment[],
    billAccountNumberList: string[]
  ): boolean {
    let hasScheduledPayment = false;
    for (const scheduledPayment of scheduledPayments) {
      for (const ba of scheduledPayment.billAccounts) {
        hasScheduledPayment = billAccountNumberList.some(
          billaccountNumberItem => billaccountNumberItem === ba.billAccountNumber
        );
        if (hasScheduledPayment) {
          return hasScheduledPayment;
        }
      }
    }
    return hasScheduledPayment;
  }
}
